var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectrometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fd7",
    d: "M47.6 74.8L85.4 12.4 75.4 62.4 95.4 62.4 56.5 115.6 66.6 74.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.6 74.8L70.4 12.4 60.4 62.4 80.4 62.4 41.5 115.6 51.6 74.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f4a54",
    d: "M41.5,118.6c-0.4,0-0.9-0.1-1.3-0.3c-1.3-0.6-2-2.1-1.6-3.4l10-40c0.4-1.6,2-2.6,3.6-2.2c1.6,0.4,2.6,2,2.2,3.6l-6.3,25.1l26.3-36.1H60.4c-0.9,0-1.8-0.4-2.3-1.1c-0.6-0.7-0.8-1.6-0.6-2.5l10-50c0.3-1.6,1.9-2.7,3.5-2.4c1.6,0.3,2.7,1.9,2.4,3.5L64,59.4h16.3c1.1,0,2.2,0.6,2.7,1.6s0.4,2.2-0.3,3.1l-38.9,53.2C43.4,118.2,42.5,118.6,41.5,118.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f4a54",
    d: "M32.6,77.8c-0.5,0-1.1-0.1-1.6-0.4c-1.4-0.9-1.9-2.7-1-4.1l37.8-62.4c0.9-1.4,2.7-1.9,4.1-1c1.4,0.9,1.9,2.7,1,4.1L35.2,76.3C34.6,77.2,33.6,77.8,32.6,77.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrometer);
export default __webpack_public_path__ + "static/media/electrometer.227b469dc8ed0880256e55eecba1067c.svg";
export { ForwardRef as ReactComponent };